module.exports = __webpack_public_path__ + "img/cpio.9a46d9bc.png";